import { Backspace, Visibility, VisibilityOff } from "@mui/icons-material"
import { ButtonGroup, Button, Typography, Tooltip, tooltipClasses, styled, Chip } from "@mui/material"
import { AssignmentLate, AssignmentTurnedIn, Block } from '@mui/icons-material';
import { useState } from "react";
import MultiColorProgressBar from "./MultiColorProgressBar";



export const CustomParamButton = ({param_value, toggleParam, showLoader, label}) => {
    const [load, setShowLoader] = useState(false)
    const handleValue = (p) => {
        if (showLoader) {
            setShowLoader(true)
            setTimeout(function () {
                setShowLoader(false)
            }, 1000)
        }
        toggleParam(p)
    }
    return (

        <ButtonGroup size="small">
            <Button loading={load} onClick={() => handleValue(true)} variant={param_value === true ? 'contained' : 'outlined'} color="success">{label}</Button>
            <Button loading={load} onClick={() => handleValue(false)} variant={param_value!== true ? 'contained' : 'outlined'} color="error">&nbsp;&nbsp;No&nbsp;&nbsp;</Button>
        </ButtonGroup>
    )

}

export const PresenceButton = ({ is_present, togglePresence, showclean, showLoader, label }) => {

    const [load, setShowLoader] = useState(false)
    const handlePresence = (p) => {
        if (showLoader) {
            setShowLoader(true)
            setTimeout(function () {
                setShowLoader(false)
            }, 1000)
        }
        togglePresence(p)
    }
    return (
        <ButtonGroup size="small">
            <Button loading={load} onClick={() => handlePresence(true)} variant={is_present === true ? 'contained' : 'outlined'} color="success">{label || "Presente"}</Button>
            <Button loading={load} onClick={() => handlePresence(false)} variant={is_present === false ? 'contained' : 'outlined'} color="error">&nbsp;&nbsp;No&nbsp;&nbsp;</Button>
            {showclean &&
                <Button onClick={() => handlePresence(undefined)} variant={is_present !== undefined ? 'contained' : 'outlined'} color="secondary" startIcon={<Backspace />}></Button>
            }

        </ButtonGroup>
    )
}

export const PresenceChip = ({ is_present }) => {

    if (is_present === true) {
        return <Typography sx={{ color: 'green' }}>Presente</Typography>
    } else if (is_present === false) {
        return <Typography sx={{ color: 'red' }}>Non Presente</Typography>
    } else {
        return <Typography sx={{ color: 'grey' }}>Non ancora compilato</Typography>
    }
}

export const PresenceIcon = ({ is_present, label }) => {
    let _label = label || 'alla manifestazione'
    if (is_present === true) {
        return (
            <HtmlTooltip arrow placement="left" title={<><Typography sx={{ backgroundColor: 'green', color: '#fff', borderRadius: 2, p: 0.5, fontSize: '1em' }}><AssignmentTurnedIn color="light" sx={{ fontSize: '1em' }} />soggetto presente {_label}</Typography></>}>
                <AssignmentTurnedIn color="success" />
            </HtmlTooltip>)
    } else if (is_present === false) {
        return (
            <HtmlTooltip arrow placement="left" title={<><Typography sx={{ backgroundColor: 'red', color: '#fff', borderRadius: 2, p: 0.5, fontSize: '1em' }}><Block color="light" sx={{ fontSize: '1em' }} />soggetto NON presente {_label}</Typography></>}>
                <Block color="error" />
            </HtmlTooltip>)
    } else {
        return (
            <HtmlTooltip arrow placement="left" title={<><Typography sx={{ backgroundColor: 'lightgrey', color: '#000', borderRadius: 2, p: 0.5, fontSize: '1em' }}><AssignmentLate color="warning" sx={{ fontSize: '1em' }} />presenza {_label} non ancora compilata</Typography></>}>
                <AssignmentLate color="warning" />
            </HtmlTooltip>)
    }
}



const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#f5f5f9',
        color: 'rgba(0, 0, 0, 0.87)',
        maxWidth: 220,
        fontSize: theme.typography.pxToRem(12),
        border: '1px solid #dadde9',
    },
}));

export const PresenceSummary = ({ element_list, title }) => {
    const present_count = element_list.filter(c => c.is_present === true).length
    const notpresent_count = element_list.filter(c => c.is_present === false).length
    const not_count = element_list.filter(c => c.is_present === undefined).length


    return (
        <>


            <HtmlTooltip arrow placement="bottom" title={
                <>
                    <Typography>{title}</Typography>
                    {present_count > 0 &&
                        <><Typography sx={{ backgroundColor: 'green', color: '#fff', borderRadius: 2, p: 0.5, fontSize: '1em' }}><AssignmentTurnedIn fontSize="1em" /> {present_count} soggetti presenti</Typography></>
                    }
                    {notpresent_count > 0 &&
                        <><Typography sx={{ backgroundColor: 'red', color: '#fff', borderRadius: 2, p: 0.5, fontSize: '1em' }}><Block fontSize="1em" />{notpresent_count} soggetti NON presenti</Typography></>
                    }
                    {not_count > 0 &&
                        <><Typography sx={{ backgroundColor: 'orange', color: '#000', borderRadius: 2, p: 0.5, fontSize: '1em' }}><AssignmentLate fontSize="1em" />{not_count} soggetti con presenza non ancora compilata</Typography></>
                    }
                </>}
            >
                {present_count > 0 &&
                    <Chip size="small" color="success" label={present_count} />
                }
                {notpresent_count > 0 &&
                    <Chip size="small" color="error" label={notpresent_count} />
                }
                {not_count > 0 &&
                    <Chip size="small" color="light" label={not_count} />
                }
            </HtmlTooltip>



        </>
    )
}



export const TogglePresenceButton = ({ setShowNotPresent, showNotPresent, label }) => {
    const _label = label || ' non presenti'
    return (
        <ButtonGroup size="small">
            <Button onClick={() => setShowNotPresent(true)} variant={showNotPresent ? 'contained' : 'outlined'} startIcon={<Visibility />}>Visualizza{_label}</Button>
            <Button onClick={() => setShowNotPresent(false)} variant={!showNotPresent ? 'contained' : 'outlined'} startIcon={<VisibilityOff />} >Nascondi{_label}</Button>
        </ButtonGroup>
    )
}

const fs = '1em'
export const PresenceSummaryStats = ({ stat_data, index }) => {
    return (
        <>

            {stat_data.count_present}-{stat_data.count_not_present} /{stat_data.count_total}
            <HtmlTooltip title={<><Typography>presenza soggetti</Typography>
                {stat_data.count_present > 0 && <Typography sx={{ fontSize: fs }}> <AssignmentTurnedIn color="success" sx={{ fontSize: fs }} />{stat_data.count_present} presenti</Typography>}
                {stat_data.count_not_present > 0 && <Typography sx={{ fontSize: fs }}><Block color="error" sx={{ fontSize: fs }} />{stat_data.count_not_present} non presenti</Typography>}

                {stat_data.count_total - stat_data.count_not_present - stat_data.count_present > 0 && <Typography sx={{ fontSize: fs }}><AssignmentLate color="warning" sx={{ fontSize: fs }} />{stat_data.count_total - stat_data.count_not_present - stat_data.count_present} non compilati</Typography>}
            </>
            } arrow>
                <span>

                    <MultiColorProgressBar key={index} is_summary={true} element_list={stat_data} />
                </span>
            </HtmlTooltip>
        </>
    )

}